import owd from 'owd/owd';
import _ from 'underscore';
// import random from 'owd/utils/random';
// import br from 'owd/utils/browser';
// import 'lib/jquery-inview';

export default class Pagination extends owd.Component {
	init() {
		this.$up = this.$element.find('[data-pagination-up]');
		this.$down = this.$element.find('[data-pagination-down]');
		this.$container = this.$element.find('[data-pagination-container]');
		this.$strip = this.$element.find('[data-pagination-strip]');
		this.$items = this.$element.find('[data-pagination-item]');

		this.swiper = this.dom.$body.find('[data-slider="home-hero"]').data('swiperInstance');

		this.hasButtonHovered = false;
		this.wasClicked = false;

		this.countOffsets();
		this.bind();
	}

	countOffsets() {
		this.containerOffset = this.$container.offset().top;
		this.containerHeight = this.$container.outerHeight();
		this.stripOffset = this.$strip.offset().top;
		this.stripHeight = this.$strip.outerHeight();
		this.containerHeight = this.$container.outerHeight();
		this.itemHeight = this.$items.eq(0).outerHeight();
		this.itemsOffsets = [];
	}

	multiplyContent() {
		let stripContent = this.$strip.html();
		let multiplier = Math.ceil(10 / this.$items.length) + 1;

		for (var i = 0; i < multiplier; i++) {
			this.$strip.append(stripContent);
		}

		this.$items = this.$element.find('[data-pagination-item]');

		this.$items.each((i, obj) => {
			this.itemsOffsets.push($(obj).offset().top - this.stripOffset);
		})

		this.stripCenterOffset = .5 * (this.itemHeight + (this.itemsOffsets[1] - this.itemsOffsets[0]) - this.containerHeight);
	}

	moveUp() {
		this.$container.animate({
			scrollTop: this.$container[0].scrollTop - 30
		}, 300, 'easeOutQuint');
	}

	moveDown() {
		this.$container.animate({
			scrollTop: this.$container[0].scrollTop + 30
		}, 300, 'easeOutQuint');
	}

	bind() {
		this.on('click', this.$up, () => {
			this.moveUp();
		})

		this.on('click', this.$down, () => {
			this.moveDown();
		})

		this.on('click', this.$strip, this.$items, (e) => {
			let $curr = $(e.target);
			let index = $curr.index();
			let sliderIndex = $curr.data('slider-index');
			let scrollTop = this.itemsOffsets[index] + this.stripCenterOffset;

			this.wasClicked = true;

			// console.log(scrollTop);

			if (scrollTop < 0) scrollTop = scrollTop + this.stripHeight;

			this.swiper.slideTo(index);
			this.$items.removeClass('is-active');
			$('[data-slider-index=' + sliderIndex + ']').addClass('is-active');

			this.$container.animate({
				scrollTop: scrollTop
			}, 300, 'easeOutQuint');

			// this.$container.scrollTop(scrollTop)
		})

		this.on('init', this.swiper, () => {
			this.multiplyContent();
			this.$container.scrollTop(this.stripHeight + this.stripCenterOffset);
			$('[data-slider-index="0"]').addClass('is-active');
		})

		this.on('scroll', this.$container, () => {
			if (!this.wasClicked) {
				let scroll = this.$container.scrollTop();

				if (scroll > this.stripHeight) {
					this.$container.scrollTop(scroll - this.stripHeight);
				} else if (scroll === 0) {
					this.$container.scrollTop(this.stripHeight);
				}
			}
			// console.log(scroll);
		})

		this.on('scroll', this.$container, _.debounce(() => {
			let scroll = this.$container.scrollTop();

			if (scroll > this.stripHeight) {
				this.$container.scrollTop(scroll - this.stripHeight);
			} else if (scroll === 0) {
				this.$container.scrollTop(this.stripHeight);
			}
			
			this.wasClicked = false;
		}, 100))
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('pagination', {
	component: Pagination
});
